import { ca } from '@cian/analytics';
import { TDeviceType } from '@cian/ui-kit';

import { getSiteType } from '../../../../../common/utils/analytics';

interface ITrackPinPaginationClickParams {
  direction: 'prev' | 'next';
  /** realtyId объявления, на которое перешли */
  realtyId: number;
  /** Позиция этого объявления в пине, с 1 */
  position: number;
  isDesktopListingVisible: boolean;
  deviceType: TDeviceType;
}

/** События №112/№113: листалка мультипина перешла к следующему/предыдущему объявлению пина */
export function trackPinPaginationClick({
  direction,
  realtyId,
  position,
  isDesktopListingVisible,
  deviceType,
}: ITrackPinPaginationClickParams): void {
  // Листалка живёт на карте: рядом с листингом - гибрид, без него - карта целиком
  const pageType = isDesktopListingVisible ? 'ListingHybrid' : 'Map';

  ca('eventSite', {
    name: 'oldevent',
    category: pageType,
    action: direction === 'next' ? 'click_next_object' : 'click_previous_object',
    label: 'multipin',
    page: { pageType, siteType: getSiteType(deviceType) },
    products: [{ id: realtyId, position }],
  });
}
